export class UpdateRmRackpositionRequest{
    selectedRows: any[];
    constructor(selectedRows: any[]){
        this.selectedRows = selectedRows;
    }
}